import { FC } from 'react'
import { useLocation } from 'react-router-dom'
import FoodNav from './FoodNav'
import OthersNav from './OthersNav'
import PackagingNav from './PackagingNav'
import './index.scss'

const Menu: FC = () => {
  const { pathname } = useLocation()

  return (
    <nav className="menu">
      <div className="menu-items">
        {pathname.startsWith('/food') && <FoodNav />}
        {pathname.startsWith('/packaging') && <PackagingNav />}
        {!pathname.startsWith('/food') && !pathname.startsWith('/packaging') && <OthersNav />}
      </div>
    </nav>
  )
}

export default Menu
